/** Desktop kolonunun varsayılan genişliği — mevcut sabit ölçü. */
export const DOCK_DEFAULT_WIDTH = 400;
export const DOCK_MIN_WIDTH = 360;
export const DOCK_MAX_WIDTH = 720;

/**
 * Bu genişliğin altında dock içindeki sohbet balonları %100 olur.
 * Tam sayfa chat bu eşiği kullanmaz; mevcut max-w yerleşimi kalır.
 */
export const DOCK_COMPACT_BUBBLE_WIDTH = 560;

const LEFT_SIDEBAR_OPEN = 288;
const LEFT_SIDEBAR_RAIL = 80;
const MIN_CONTENT_WIDTH = 360;

export function dockViewportMax(
  viewportWidth: number,
  leftSidebarOpen: boolean,
): number {
  const left = leftSidebarOpen ? LEFT_SIDEBAR_OPEN : LEFT_SIDEBAR_RAIL;
  const available = viewportWidth - left - MIN_CONTENT_WIDTH;
  return Math.min(DOCK_MAX_WIDTH, Math.max(DOCK_MIN_WIDTH, available));
}

export function clampDockWidth(width: number, viewportMax?: number): number {
  const max = viewportMax ?? DOCK_MAX_WIDTH;
  const n = Number(width);
  if (!Number.isFinite(n)) return DOCK_DEFAULT_WIDTH;
  return Math.round(Math.min(max, Math.max(DOCK_MIN_WIDTH, n)));
}
